import lazyLoad from 'app/shared-components/util/lazyLoad';
import withClientContext from 'app/shared-components/util/withClientContext';
const ClientsApp= lazyLoad(() => import('./ClientsApp'));
const ClientForm = lazyLoad(() => import('app/shared-components/client/ClientForm'));
const ClientTeams = lazyLoad(() => import('app/shared-components/client/ClientTeams'));
const ClientAuthorizedUsers = lazyLoad(() => import('app/shared-components/client/ClientAuthorizedUsers'));
const AuthorizedClientChat = lazyLoad(() => import('./AuthorizedClientChat'));
const AuthorizedUserChatMulti = lazyLoad(() => import('./AuthorizedUserChatMulti'));
const RecordsApp = lazyLoad(() => import('app/shared-components/client-records/views/RecordsApp'));
const RecordTemplatesApp = lazyLoad(() => import('./RecordTemplatesApp'));
const ClientTasksApp = lazyLoad(() => import('./tasks/ClientTasksApp'));
const ClientInfoView = lazyLoad(() => import('app/shared-components/client/ClientInfoView'));
const ClientFiles = lazyLoad(() => import('app/shared-components/client/ClientFiles'));
const ClientServicesApp = lazyLoad(() => import('app/shared-components/client/ClientServicesApp'));
const ClientSessionsTab = lazyLoad(() => import('app/shared-components/client/ClientSessionsTab'));
const BillingRecordsApp = lazyLoad(() => import('./billing/BillingRecordsApp'));
const SuperbillsApp = lazyLoad(() => import('./billing/SuperbillsApp'));

// Lazy load shared ManageClient and wrap with unified ClientAppContext
const ManageClient = lazyLoad(async () => {
  const { default: Component } = await import('app/shared-components/client/manage/ManageClient');
  return { default: withClientContext(Component) };
});


const ClientsAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  helpConfig: {
    query: 'client management',
    tag: 'clients',
    title: 'Clients'
  },
  routes: [
    {
      path: 'apps/clients',
      element: <ClientsApp />,
      children: [
        {
          path: ':id',
          element: <ClientForm />,
        },
        {
          path: 'authorized',
          element: <div/>,
          helpConfig: {
            query: 'authorized clients',
            tag: 'clients',
            title: 'Authorized Clients'
          }
        },
        {
          path: 'authorized/:id',
          element: <AuthorizedClientChat/>,
          helpConfig: {
            query: 'authorized clients',
            tag: 'clients',
            title: 'Authorized Clients'
          }
        },
        {
          path: 'chat/:id',
          element: <AuthorizedUserChatMulti/>,
        },
        {
          path: 'pending',
          element: <div/>,
          helpConfig: {
            query: 'client pending authorization',
            tag: 'clients',
            title: 'Pending Authorizations'
          }
        },
        {
          path: 'templates',
          element: <RecordTemplatesApp />,
          helpConfig: {
            query: 'record templates',
            title: 'Record Templates'
          }
        },
        {
          path: 'services',
          element: <div />,
          helpConfig: {
            query: 'client services',
            title: 'Client Services'
          }
        },
        {
          path: 'sessions',
          element: <div />,
          helpConfig: {
            query: 'client sessions',
            title: 'Client Sessions'
          }
        },
      ],
    },
    {
      path: 'apps/client/:clientId',
      element: <ManageClient />,
      helpConfig: {
        query: 'client management',
        tag: 'clients',
        title: 'Manage Client'
      },
      children: [
        {
          path: '',
          element: <ClientInfoView />,
        },
        {
          path: 'records/insurance',
          element: <RecordsApp displayMode="insurance" />,
        },
        {
          path: 'records/providers',
          element: <RecordsApp displayMode="providers" />,
        },
        {
          path: 'records/diagnosis',
          element: <RecordsApp displayMode="diagnosis" />,
        },
        {
          path: 'records/template/:templateId',
          element: <RecordsApp />,
          helpConfig: {
            query: 'client record management',
            title: 'Client Record Management'
          },
        },
        {
          path: 'teams',
          element: <ClientTeams />,
          helpConfig: {
            query: 'client teams',
            title: 'Client Teams'
          },
        },
        {
          path: 'teams/view/:teamId',
          element: <ClientTeams />,
          helpConfig: {
            query: 'client teams',
            title: 'Client Teams'
          },
        },
        {
          path: 'teams/add/view/:teamId',
          element: <ClientTeams />,
          helpConfig: {
            query: 'client teams',
            title: 'Client Teams'
          },
        },
        {
          path: 'teams/add',
          element: <ClientTeams />,
          helpConfig: {
            query: 'client teams',
            title: 'Client Teams'
          },
        },
        {
          path: 'users',
          element: <ClientAuthorizedUsers />,
          helpConfig: {
            query: 'client authorized users',
            tag: 'clients',
            title: 'Client Authorized Users'
          },
        },        
        {
          path: 'users/view/:userId',
          element: <ClientAuthorizedUsers />,
        },
        {
          path: 'users/chat/:userId',
          element: <ClientAuthorizedUsers />,
        },
        {
          path: 'users/pending',
          element: <ClientAuthorizedUsers />,
          helpConfig: {
            query: 'client authorized users',
            tag: 'clients',
            title: 'Client Authorized Users'
          },
        },
        {
          path: 'users/pending/view/:userId',
          element: <ClientAuthorizedUsers />,
        },
        {
          path: 'users/add',
          element: <ClientAuthorizedUsers />,
        },
        {
          path: 'users/add/view/:userId',
          element: <ClientAuthorizedUsers />,
        },
        {
          path: 'records',
          element: <RecordsApp displayMode="templated" />,
          helpConfig: {
            query: 'client record management',
            title: 'Client Record Management'
          },
        },
        {
          path: 'tasks',
          element: <ClientTasksApp />,
          helpConfig: {
            query: 'client tasks',
            title: 'Client Tasks'
          },
        },
        {
          path: 'sessions',
          element: <ClientSessionsTab />,
          helpConfig: {
            query: 'client sessions',
            title: 'Client Sessions'
          },
        },
        {
          path: 'files',
          element: <ClientFiles />,
          helpConfig: {
            query: 'client files management',
            title: 'Client Files Management'
          },
        },
        {
          path: 'files/:folderId',
          element: <ClientFiles />,
          helpConfig: {
            query: 'client files management',
            title: 'Client Files Management'
          },
        },
        {
          path: 'billing',
          element: <BillingRecordsApp />,
          helpConfig: {
            query: 'client billing records',
            title: 'Client Billing'
          },
        },
        {
          path: 'superbills',
          element: <SuperbillsApp />,
          helpConfig: {
            query: 'client superbills',
            title: 'Client Superbills'
          },
        },
      ],
    },
  ],
};

export default ClientsAppConfig;
